import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const DashboardApi = {
  getDashboardVentas: async (year) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/api/dashboard/ventas_dashboard`,
        {
          params: { year },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching dashboard ventas:", error);
      throw error;
    }
  },

  getDashboardDesigns: async (year) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/api/dashboard/ventas_dashboard_designs`,
        {
          params: { year },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching dashboard designs:", error);
      throw error;
    }
  },
};
